export default __webpack_public_path__ + "static/media/28.bad0c296.png";